import _ from "lodash";

export const texts = [{
  id: 'h1',
  name: 'Heading 1',
  render: (styles) => {
    return <h1 style={styles}>Heading 1</h1>
  },
  data: {
    properties: {
      desktop: {
        animation: null,
        color: null,
        layout: {
          transform: {
            translate: `0px, 0px`,
            rotate: "0deg",
          },
          width: "auto",
          height: "auto",
        },
        fontSize: "67",
        lineSpacing: "1.2",
        letterSpacing: "0",
      },
      mobile: {
        animation: null,
        color: null,
        layout: {
          transform: {
            translate: `0px, 0px`,
            rotate: "0deg",
          },
          width: "335px",
          height: "auto",
        },
        fontSize: "32",
        lineSpacing: "1.2",
        letterSpacing: "0",
      },
    },
    content: '<h1>Heading 1</h1>'
  }
}, {
  id: 'h2',
  name: 'Heading 2',
  render: (styles) => {
    return <h2 style={styles} >Heading 2</h2>
  },
  data: {
    properties: {
      desktop: {
        animation: null,
        color: null,
        layout: {
          transform: {
            translate: `0px, 0px`,
            rotate: "0deg",
          },
          width: "auto",
          height: "auto",
        },
        fontSize: "50",
        lineSpacing: "1.2",
        letterSpacing: "0",
      },
      mobile: {
        animation: null,
        color: null,
        layout: {
          transform: {
            translate: `0px, 0px`,
            rotate: "0deg",
          },
          width: "335px",
          height: "auto",
        },
        fontSize: "24",
        lineSpacing: "1.2",
        letterSpacing: "0",
      },
    },
    content: '<h2>Heading 2</h2>'
  }
}, {
  id: 'h3',
  name: 'Heading 3',
  render: (styles) => {
    return <h3 style={styles}>Heading 3</h3>
  },
  data: {
    properties: {
      desktop: {
        animation: null,
        color: null,
        layout: {
          transform: {
            translate: `0px, 0px`,
            rotate: "0deg",
          },
          width: "auto",
          height: "auto",
        },
        fontSize: "37",
        lineSpacing: "1.2",
        letterSpacing: "0",
      },
      mobile: {
        animation: null,
        color: null,
        layout: {
          transform: {
            translate: `0px, 0px`,
            rotate: "0deg",
          },
          width: "335px",
          height: "auto",
        },
        fontSize: "18",
        lineSpacing: "1.2",
        letterSpacing: "0",
      },
    },
    content: '<h3>Heading 3</h3>'
  }
}, {
  id: 'h4',
  name: 'Heading 4',
  render: (styles) => {

    return <h4 style={styles}>Heading 4</h4>
  },
  data: {
    properties: {
      desktop: {
        animation: null,
        color: null,
        layout: {
          transform: {
            translate: `0px, 0px`,
            rotate: "0deg",
          },
          width: "auto",
          height: "auto"
        },
        fontSize: "28",
        lineSpacing: "1.2",
        letterSpacing: "0",
      },
      mobile: {
        animation: null,
        color: null,
        layout: {
          transform: {
            translate: `0px, 0px`,
            rotate: "0deg",
          },
          width: "335px",
          height: "auto",
        },
        fontSize: "21",
        lineSpacing: "1.2",
        letterSpacing: "0",
      },
    },
    content: '<h4>Heading 4</h4>'
  }
}, {
  id: 'h5',
  name: 'Heading 5',
  render: (styles) => {

    return <h5 style={styles}>Heading 5</h5>
  },
  data: {
    properties: {
      desktop: {
        animation: null,
        color: null,
        layout: {
          transform: {
            translate: `0px, 0px`,
            rotate: "0deg",
          },
          width: "auto",
          height: "auto"
        },
        fontSize: "24",
        lineSpacing: "1.2",
        letterSpacing: "0",
      },
      mobile: {
        animation: null,
        color: null,
        layout: {
          transform: {
            translate: `0px, 0px`,
            rotate: "0deg",
          },
          width: "335px",
          height: "auto",
        },
        fontSize: "19",
        lineSpacing: "1.2",
        letterSpacing: "0",
      },
    },
    content: '<h5>Heading 5</h5>'
  }
}, {
  id: 'h6',
  name: 'Heading 6',
  render: (styles) => {

    return <h6 style={styles}>Heading 6</h6>
  },
  data: {
    properties: {
      desktop: {
        animation: null,
        color: null,
        layout: {
          transform: {
            translate: `0px, 0px`,
            rotate: "0deg",
          },
          width: "auto",
          height: "auto"
        },
        fontSize: "16",
        lineSpacing: "1.2",
        letterSpacing: "0",
      },
      mobile: {
        animation: null,
        color: null,
        layout: {
          transform: {
            translate: `0px, 0px`,
            rotate: "0deg",
          },
          width: "335px",
          height: "auto",
        },
        fontSize: "16",
        lineSpacing: "1.2",
        letterSpacing: "0",
      },
    },
    content: '<h6>Heading 6</h6>'
  }
}, {
  id: 'p',
  name: 'Paragraph',
  render: (styles) => {
    return <p style={styles}>Paragraph</p>
  },
  data: {
    properties: {
      desktop: {
        animation: null,
        color: null,
        layout: {
          transform: {
            translate: `0px, 0px`,
            rotate: "0deg",
          },
          width: "auto",
          height: "auto"
        },
        fontSize: "16",
        lineSpacing: "1.2",
        letterSpacing: "0",
      },
      mobile: {
        animation: null,
        color: null,
        layout: {
          transform: {
            translate: `0px, 0px`,
            rotate: "0deg",
          },
          width: "335px",
          height: "auto",
        },
        fontSize: "16",
        lineSpacing: "1.2",
        letterSpacing: "0",
      },
    },
    content: '<p>Paragraph</p>'
  }
}];
